import '@/css/m/game-info/index.scss'

// require('jquery.transit')

require('widgets/mobile_common')
require('mobile/common-components/index.js')
require('./sections/area-mater')
require('./sections/pn-detail')

var Newswaterfall = require('./sections/pn-news'),
  renderShareTip = require('mobile/widgets/renderShareTip')

var pingjs = require('widgets/ping')
pingjs.applyTrackLink()
pingjs.applyTrackBlock()
pingjs.applyTrackArea()

// see more http://ued.local.17173.com/wiki/pages/viewpage.action?pageId=16908433
window.mesConfig = {
  link: window.location.href.replace('#fx', '')
}
if (window.location.href.indexOf('#fx') != -1 && /micromessenger/i.test(navigator.userAgent)) {
  renderShareTip()
}

if (module.hot) {
  module.hot.accept()
}

$(function () {
  window.currentIsNews = false;
  var firstWatchNews = true;

  if ($('.js-tab').length > 0) {
    $(".js-tab").each(function () {
      var tab = $(".tab:eq(0) > a", $(this));
      var tabPn = $(".tab-pn:eq(0) > div", $(this))
      tab.on('click', function () {
        var index = $(this).index();
        tab.eq(index).addClass('active').siblings().removeClass('active');
        tabPn.eq(index).show().siblings().hide();
        if (index == 0) {
          tabPn.eq(1).show();
          window.currentIsNews = false;
        }
        if (index == 1) {
          window.currentIsNews = false;
        }
        if (index == 2) {
          window.currentIsNews = true;
          if (firstWatchNews) {
            firstWatchNews = false;
            new Newswaterfall(window.currentIsNews);
          }
        }
        if (index == 3) {
          window.currentIsNews = false;
        }
      })
    });
  };
  var worthTimer = '';
  var worthCount = 0;
  worthTimer = setInterval(function () {
    if ($('.gb-comment-mod-hd [data-role="worthState"]').length > 0 && $('.gb-comment-mod-hd [data-role="worthState"]').is(":visible") && $('.gb-comment-mod-hd [data-role="worthState"]').html() != '') {
      var $worth = $('.gb-comment-mod-hd [data-role="worthState"]');
      var isWorth = $worth.html().split('span>')[1];
      var per = $worth.html().split('<span')[0].split('%')[0];
      if (isWorth.indexOf('不值') == -1) {
        $('.mod-worth').find('b').html(per).end().show();
      }
      clearInterval(worthTimer);
      // console.log($worth.html())
    } else {
      worthCount++;
      if (worthCount == 20) {
        clearInterval(worthTimer);
      }
      // console.log('else')
    }
  }, 100);

  if ($('.btn-view-devsay').length > 0) {
    var cacheSay = $('.mod-say .mod-con').html();
    $('.btn-view-devsay').on('click', function () {
      if ($(this).text() == '查看详细') {
        $(this).text('隐藏部分');
        $('.mod-say .mod-con').html($('#tmpl-devsay-detail').html());
      } else {
        $(this).text('查看详细');
        $('.mod-say .mod-con').html(cacheSay);
      }

    });
  }

  // 临时修改 公主连结（4053273）隐藏新三块和新闻最新动态
  if (ued.gameCode == '4053273') {
    $('.mod-xsk').hide()
  }

  // 最新活动 走活动平台
  function goToBl() {
    // 定位到新闻爆料
    if ($('#bl_news').length && location.href.indexOf('#bl_news') > -1) {
      $('html, body').stop().animate({
        scrollTop: $('#bl_news').offset().top - 165,
      }, 200);
    }
  }
  if ($('[data-actid]').length) {
    var actId = $('[data-actid]').data('actid')
    $.ajax({
      url: 'https://actapp.17173.com/api/v2/activity/' + actId + '/info',
      dataType: 'jsonp',
      success: function (res) {
        $('[data-actid]').html('<div class="mod-act"><div class="hd"><div class="tit">最新活动</div><a href="' + res.activityUrl + '"target="_blank" class="btn-go-act">参与活动</a></div><div class="bd"><div class="pic"><a href="' + res.activityUrl + '" target="_blank"><img src="' + res.activityImage + '" alt="" /></a></div><div class="box-txt"><div class="tit"><a href="' + res.activityUrl + '" target="_blank">' + res.name + '</a></div><div class="txt">' + res.description + '</div></div></div></div>')
        if (location.href.indexOf('#act') > -1) {
          $('html, body').stop().animate({
            scrollTop: $('[data-actid]').offset().top - 165,
          }, 0);
        }
        goToBl()
      }
    })
  } else {
    goToBl()
  }
  var $noticeContainer = $('[data-notice]');
  if ($noticeContainer.length) {
    var $noticeItems = $noticeContainer.find('.notice-item');
    if ($noticeItems.length > 1) {
      var currentIndex = 0;
      var scrollInterval;

      // 设置公告容器样式
      $noticeContainer.css({
        'position': 'relative',
        'overflow': 'hidden',
        'height': '20px'
      });

      // 克隆第一个公告到最后,形成循环
      var $firstClone = $noticeItems.first().clone();
      $noticeContainer.append($firstClone);

      // 初始化公告项样式
      var itemHeight = 20;
      $noticeItems = $noticeContainer.find('.notice-item'); // 重新获取包含克隆项的列表
      $noticeItems.each(function(index) {
        $(this).css({
          'position': 'absolute',
          'width': '100%',
          'transition': 'top 0.5s ease',
          'top': (index * itemHeight) + 'px'
        });
      });

      // 开始滚动
      function startScroll() {
        scrollInterval = setInterval(function() {
          currentIndex++;

          // 移动所有项
          $noticeItems.each(function() {
            var $item = $(this);
            var newTop = parseInt($item.css('top')) - itemHeight;
            $item.css('top', newTop + 'px');
          });

          // 当克隆项滚动到可视区域时,无缝重置到第一项
          if (currentIndex >= $noticeItems.length - 1) {
            setTimeout(function() {
              // 禁用过渡效果
              $noticeItems.css('transition', 'none');

              // 重置位置：将克隆项移到底部，其他项相应调整
              $noticeItems.each(function(index) {
                var $item = $(this);
                if (index === $noticeItems.length - 1) {
                  // 克隆项移到底部
                  $item.css('top', (($noticeItems.length - 1) * itemHeight) + 'px');
                } else {
                  // 其他项向上移动一个位置
                  $item.css('top', (index * itemHeight) + 'px');
                }
              });

              currentIndex = 0;

              // 重新启用过渡效果
              setTimeout(function() {
                $noticeItems.css('transition', 'top 0.5s ease');
              }, 50);
            }, 500); // 等待当前动画完成
          }
        }, 3000);
      }

      // 停止滚动
      function stopScroll() {
        if (scrollInterval) {
          clearInterval(scrollInterval);
        }
      }

      // 移动端触摸交互优化
      var touchStartTime = 0;
      var isScrollPaused = false;

      // 触摸开始时暂停滚动
      $noticeContainer.on('touchstart', function(e) {
        touchStartTime = Date.now();
        isScrollPaused = true;
        stopScroll();
      });

      // 触摸结束后延迟恢复滚动
      $noticeContainer.on('touchend', function(e) {
        var touchDuration = Date.now() - touchStartTime;
        // 如果触摸时间较短（小于200ms），认为是快速滑动，立即恢复滚动
        // 如果触摸时间较长，延迟2秒后恢复滚动，给用户阅读时间
        var resumeDelay = touchDuration < 200 ? 500 : 2000;
        
        setTimeout(function() {
          if (isScrollPaused) {
            isScrollPaused = false;
            startScroll();
          }
        }, resumeDelay);
      });

      // 点击公告区域时暂停3秒，但允许跳转
      $noticeContainer.on('click', function(e) {
        // 不阻止默认行为，允许跳转到公告详情
        isScrollPaused = true;
        stopScroll();
        
        setTimeout(function() {
          if (isScrollPaused) {
            isScrollPaused = false;
            startScroll();
          }
        }, 3000);
      });

      // 开始自动滚动
      startScroll();
    }
  }

  // iso android添加spmid 初始化的时候修改链接
  if ($('a.js-getspmid').length > 0) {
    const href = $('a.js-getspmid').attr('href') || '';
    
    // 判断链接是否已包含 spm_id 参数
    if (href.indexOf('spm_id=') === -1) {
      var spmId = '';
      if (ued && ued.bi && typeof ued.bi.getSpmId === 'function') {
        spmId = ued.bi.getSpmId() + '.mod_mnewgameinfo.0';
      }
      
      // 判断链接是否已有其他参数
      const connector = href.indexOf('?') === -1 ? '?' : '&';
      $('a.js-getspmid').attr('href', href + connector + 'spm_id=' + spmId);
    }
  }

  // 引入游戏下载指引交互功能
  var initDownloadGuide = require('./download-guide.js');
  
  // 初始化游戏下载指引交互功能
  var downloadGuide = initDownloadGuide();

})
